import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import Layout from "./hocs/Layout";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import StoreRoute from "./routes/StoreRoute";
import Head from "./hocs/Head";
import { HomePageURL } from "./assets/const";
import TeamRoute from "./routes/TeamRoute";
import OrderRoute from "./routes/OrderRoute";
import TargetRoute from "./routes/TargetRoute";
import FGRoute from "./routes/FGRoute";
import ProductRoute from "./routes/ProductRoute";
import TransferRoute from "./routes/TransferRoute";
import InvoiceRoute from "./routes/InvoicesRoute";

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Head />
        <Layout>
          <ScrollToTop />
          <Routes>
            <Route path={`${HomePageURL}/`} element={<Home />} />
          </Routes>
          <StoreRoute />
          <OrderRoute />
          <InvoiceRoute />
          <TeamRoute />
          <TargetRoute />
          <FGRoute />
          <ProductRoute />
          <TransferRoute />
        </Layout>
      </Router>
    </Provider>
  );
}

export default App;
